module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Stick.4239e3d0.png";